import { useCurrentUserStore, useLocation } from '@yarmill/utils';
import { observer } from 'mobx-react-lite';
import { Fragment, ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { useIsLoggedIn } from '../auth/hooks';
import { createPermissionScopeFilter } from '../permissions/utils';
import { PrivateRoute } from './private-route';
import { routes } from './routes';
import { Page } from '../page/page';

const newModules = ['metodej', 'planner', 'okr'];

const publicRoutes = routes
  .filter(route => route.public)
  .map(route => route.path.substring(1));

function getModuleFromPath(pathname: string) {
  return pathname.split('/')[1];
}

export const RoutesList = observer(function RoutesList(): ReactElement {
  const currentUser = useCurrentUserStore();
  const isLoggedIn = useIsLoggedIn();
  const location = useLocation();
  const allowedRoutes = isLoggedIn
    ? routes.filter(createPermissionScopeFilter(currentUser))
    : routes;

  const currentModule = getModuleFromPath(location.pathname);
  const Wrapper =
    newModules.includes(currentModule) || publicRoutes.includes(currentModule)
      ? Fragment
      : Page;

  return (
    <Wrapper>
      {allowedRoutes.map(route =>
        route.public ? (
          <Route key={route.path} exact={route.exact} path={route.path}>
            <route.component />
          </Route>
        ) : (
          <PrivateRoute
            key={route.path}
            path={route.path}
            component={route.component}
            exact={route.exact}
          />
        )
      )}
    </Wrapper>
  );
});
